// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35PBR","title":"styles_title__G-oZ0"};